export default __webpack_public_path__ + "static/media/me.4ac0f765.svg";